var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9082 21V3C2.9082 2.73478 3.01356 2.48043 3.2011 2.29289C3.38863 2.10536 3.64299 2 3.9082 2H8.9082V0H3.9082C3.11255 0 2.34949 0.31607 1.78688 0.87868C1.22427 1.44129 0.908203 2.20435 0.908203 3L0.908203 21C0.908203 21.7956 1.22427 22.5587 1.78688 23.1213C2.34949 23.6839 3.11255 24 3.9082 24H8.9082V22H3.9082C3.64299 22 3.38863 21.8946 3.2011 21.7071C3.01356 21.5196 2.9082 21.2652 2.9082 21Z",
    fill: "#B6B6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0312 9.87897L19.4452 5.29297L18.0312 6.70697L22.2952 10.971L5.9082 11V13L22.3512 12.971L18.0292 17.293L19.4432 18.707L24.0292 14.121C24.5919 13.5587 24.9082 12.7959 24.9086 12.0004C24.9089 11.2049 24.5934 10.4418 24.0312 9.87897Z",
    fill: "#B6B6B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.52a5fc051ffe3bd459efd45034d8f997.svg";
export { ForwardRef as ReactComponent };